import React, { Component } from 'react';
import { connect } from 'react-redux';
import Aux from '../../hoc/Aux/Aux';
import HoursGrid from '../../components/Calendar/Hours/Hours'
import { Button, Nav, Navbar, NavbarBrand, NavItem, } from 'reactstrap';
import { DatePicker } from 'react-widgets'
import momentLocalizer from 'react-widgets-moment'
import 'react-datepicker/dist/react-datepicker.css';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';
import axios from '../../axios-cmk';
import { changeCalendarDate, loadTherapists, loadVisits, setCalendarDate } from '../../store/actions'
import { baseMappingWithPersonsAndHours } from '../../store/mappings'
import PersonTermDetails from "../../components/Calendar/Terms/AddTerm";
import 'react-widgets/dist/css/react-widgets.css'
import './Calendar.css';
import FontAwesome from 'react-fontawesome';
import moment from 'moment';
import Footer from "../../components/Calendar/Footer/Footer";
import Spinner from "../../components/UI/Spinner/Spinner";
import PatientDetails from '../../components/Patients/Patients'


momentLocalizer();

class Calendar extends Component {

    componentDidMount() {
        this.props.loadTherapists();
        this.props.loadVisits();
    }


    handleChange = (date) => {
        this.props.setCalendarDate(date);
        this.props.loadVisits();
    };

    nextDay = () => {
        this.props.changeCalendarDate(1);
        this.props.loadVisits();
    };

    nextWeek = () => {
        this.props.changeCalendarDate(7);
        this.props.loadVisits();
    };

    previousDay = () => {
        this.props.changeCalendarDate(-1);
        this.props.loadVisits();
    };

    previousWeek = () => {
        this.props.changeCalendarDate(-7);
        this.props.loadVisits();
    };

    render() {
        const displayed_date = moment(this.props.selectedBaseDate).format('dddd, D MMMM YYYY');
        const printed_date = moment(this.props.selectedBaseDate).format('LL');
        const content = this.props.therapists_loaded && this.props.visits_loaded ?
            (<div>
                    <HoursGrid />
                    <PersonTermDetails />
                </div>
            ) : <div className='mainLoader'>
                <Spinner />
            </div>;
        return (
            <Aux>
                <div className='Calendar container-fluid'>
                    <Navbar color="faded" light expand="md">
                        <NavbarBrand>
                            Terminarz na: <span className='dayName'>{displayed_date}</span>
                        </NavbarBrand>
                        <Nav className="ml-auto calendarNavigation" navbar>
                            <NavItem>
                                <Button outline color="secondary" onClick={this.previousWeek} className='btn-calendar'>
                                    <FontAwesome name='angle-double-left' className='action' />
                                </Button>
                            </NavItem>
                            <NavItem>
                                <Button outline color="secondary" onClick={this.previousDay} className='btn-calendar'>
                                    <FontAwesome name='angle-left' className='action' />
                                </Button>
                            </NavItem>
                            <NavItem className="mainDatePicker" sm={2}>
                                <DatePicker
                                    value={this.props.selectedBaseDate}
                                    onChange={this.handleChange}
                                    editFormat='L'
                                    format='LL'
                                />
                            </NavItem>
                            <NavItem>
                                <Button outline color="secondary" onClick={this.nextDay} className='btn-calendar'>
                                    <FontAwesome name='angle-right' className='action' />
                                </Button>
                            </NavItem>
                            <NavItem>
                                <Button outline color="secondary" onClick={this.nextWeek} className='btn-calendar'>
                                    <FontAwesome name='angle-double-right' className='action' />
                                </Button>
                            </NavItem>
                        </Nav>
                    </Navbar>
                    <div className='printHeader'>
                        <h2>Terminarz na dzień: {printed_date}</h2>
                    </div>
                    {content}
                </div>
                <Footer />
                <PatientDetails />
            </Aux>
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        loadTherapists: () => dispatch(loadTherapists()),
        loadVisits: () => dispatch(loadVisits()),
        setCalendarDate: (date) => dispatch(setCalendarDate(date)),
        changeCalendarDate: (offset) => dispatch(changeCalendarDate(offset)),
    }
};

export default connect(baseMappingWithPersonsAndHours, mapDispatchToProps)(withErrorHandler(Calendar, axios));


// WEBPACK FOOTER //
// ./src/containers/Calendar/Calendar.js